export default __webpack_public_path__ + "static/media/engrace6.d078023d.webp";